export default __webpack_public_path__ + "static/media/tj-heigh-school.4b3747c5.png";